import Component from '@glimmer/component';
import type { DetailedChangeset } from 'ember-changeset/types';
import type { TaskGroup } from 'ember-concurrency';
import { dropTaskGroup, task } from 'ember-concurrency';
import mailerTemplateChangeset from 'garaje/changesets/mailer-template-version';
import type MailerTemplateModel from 'garaje/models/mailer-template';
import { cached } from 'tracked-toolbox';

interface MailerTemplateUpdateArgs {
  mailerTemplateChangeset: DetailedChangeset<MailerTemplateModel>;
}

export interface MailerTemplateEditorComponentSignature {
  Args: {
    mailerTemplate?: MailerTemplateModel;
    title?: string;
    isOpen?: boolean;
    onUpdate?: () => void;
    onClickSave?: (args: MailerTemplateUpdateArgs) => Promise<void>;
    onClickDelete?: () => Promise<void>;
    onClickClose?: () => void;
  };

  Element: HTMLElement;
}

export default class MailerTemplateEditorComponent extends Component<MailerTemplateEditorComponentSignature> {
  @cached
  get mailerTemplateChangeset(): DetailedChangeset<MailerTemplateModel> {
    return mailerTemplateChangeset(this.args.mailerTemplate) as DetailedChangeset<MailerTemplateModel>;
  }

  get hasChanges(): boolean {
    return this.mailerTemplateChangeset.isDirty;
  }

  get isSaveDisabled(): boolean {
    const { mailerTemplateChangeset } = this;

    return !this.hasChanges || !mailerTemplateChangeset.isValid || this.updateTaskGroup.isRunning;
  }

  @dropTaskGroup updateTaskGroup!: TaskGroup<unknown>;

  saveTask = task({ group: 'updateTaskGroup' }, async (): Promise<void> => {
    const { mailerTemplateChangeset } = this;

    await this.args.onClickSave?.({ mailerTemplateChangeset });
  });

  deleteTask = task({ group: 'updateTaskGroup' }, async (): Promise<void> => {
    // TODO: what arguments get sent through here?
    await this.args.onClickDelete?.();
  });
}
